import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Blog from './components/Blog';
import BlogCategory from './components/BlogCategory';
import BlogCategoryList from './components/BlogCategoryList';
import BlogList from './components/BlogList';
import BusinessAnalysis from './components/BusinessAnalysis';
import EditBlog from './components/EditBlog';
import EditBlogcat from './components/EditBlogCat';
import Index from './components/Index';
import ProtectedRoute from './components/ProtectedRoute';
import TextEditor from './components/TextEditor';
import { ThemeProvider, useTheme } from './context/ThemeContext';
import { UserAuthContextProvider } from './context/UserAuthContext';
import Login from './Login';
import Logout from './Logout';
import Signup from './Signup';

const AppRoutes = () => {
  const { theme } = useTheme();

  return (
    <UserAuthContextProvider>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route
          path="dashboard"
          element={
            <ProtectedRoute>
              <Index />
            </ProtectedRoute>
          }
        >
          <Route index element={<BusinessAnalysis />} />
          <Route path="dash_board" element={<BusinessAnalysis />} />
          <Route path="blog-category" element={<BlogCategory />} />
          <Route path="blog-category-list" element={<BlogCategoryList />} />
          <Route path="blog-category-edit/:blog_id" element={<EditBlogcat />} />
          <Route path="edit-blog/:blog_id" element={<EditBlog />} />
          <Route path="blog" element={<Blog />} />
          <Route path="blog-list" element={<BlogList />} />
          <Route path="logout" element={<Logout />} />
        </Route>
        <Route path="ckeditor" element={<TextEditor />} />
      </Routes>
      <ToastContainer
        autoClose={2500}
        newestOnTop
        pauseOnFocusLoss={false}
        position="top-right"
        theme={theme}
      />
    </UserAuthContextProvider>
  );
};

const App = () => {
  return (
    <ThemeProvider>
      <AppRoutes />
    </ThemeProvider>
  );
};

export default App;
